<template>
  <el-dialog width="50%" center :visible="value" @close="close" @open="openDialog">
    <div class="margin-bottom">
      <el-button :disabled="!isImage" @click="rotateLeft">左旋</el-button>
      <el-button :disabled="!isImage" @click="rotateRight">右旋</el-button>
      <el-button :disabled="!isImage" @click="save">保存更改</el-button>
      <a :href="openFileUrl" target="_blank" v-if="!isImage">
        <el-button>下载</el-button>
      </a>
      <el-button v-else @click="downloadImage">下载</el-button>
    </div>

    <div class="text-center">
      <img :src="imageUrl | qiniu" width="100%" v-if="isImage" />
      <img :src="imageUrl | qiniu" v-else alt="">
    </div>
  </el-dialog>
</template>

<script>
import configMixin from '@/mixins/config'

import { getFileExtension, isImageExt } from '@/utils/qiniu'

export default {
  name: 'FwImageModal',
  mixins: [configMixin],
  props: {
    value: Boolean,
    url: String,
    filename: String,
    fileUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      degree: 0
    }
  },
  computed: {
    imageUrl () {
      if (this.url.indexOf('?imageMogr2') !== -1) {
        // 已经被旋转过，无需再加imageMogr2
        return this.url.replace(this.createRotateRegex(), this.rotateReplacer)
      } else {
        return `${this.url}?imageMogr2/rotate/${this.degree}`
      }
    },
    isImage () {
      if (this.fileUrl === '') {
        return true
      }
      return isImageExt(getFileExtension(this.fileUrl))
    },
    openFileUrl () {
      if (this.fileUrl.indexOf('http') !== -1) {
        return this.fileUrl
      }
      return this.qiniuUrl + this.fileUrl
    }
  },
  methods: {
    openDialog () {
      const result = this.createRotateRegex().exec(this.url)
      const degree = result ? Number(result[2]) : 0
      if (typeof degree === 'number' && !isNaN(degree)) {
        return (this.degree = degree)
      }
      this.degree = 0
    },
    save () {
      this.$emit('save', this.imageUrl)
    },
    rotateLeft () {
      this.degree = (this.degree - 90) % 360
    },
    rotateRight () {
      this.degree = (this.degree + 90) % 360
    },
    createRotateRegex () {
      return new RegExp(/(\S+imageMogr2\/rotate\/)(\S+)/g)
    },
    rotateReplacer (match, p1, p2) {
      return `${p1}${this.degree}`
    },
    close () {
      this.$emit('input', false)
    },
    downloadImage () {
      const img = document.createElement('img')
      const filename = this.filename || 'image-save.jpg'

      img.setAttribute('crossOrigin', 'Anonymous')
      if (this.imageUrl.indexOf('http') !== -1) {
        img.src = this.imageUrl
      } else {
        img.src = this.qiniuUrl + this.imageUrl
      }

      /**
       * 获取 blob
       * @param  {String} url 目标文件地址
       * @return {Promise}
       */
      function getBlob (url) {
        return new Promise(resolve => {
          const xhr = new XMLHttpRequest()

          xhr.open('GET', url, true)
          xhr.responseType = 'blob'
          xhr.onload = () => {
            if (xhr.status === 200) {
              resolve(xhr.response)
            }
          }
          xhr.send()
        })
      }

      img.onload = function (e) {
        const canvas = window.document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const context = canvas.getContext('2d')
        context.drawImage(img, 0, 0, img.width, img.height)
        if (canvas.msToBlob) {
          window.navigator.msSaveBlob(canvas.msToBlob(), 'image.jpg')
        } else {
          getBlob(img.src).then(blob => {
            const dlLink = document.createElement('a')
            dlLink.download = filename
            dlLink.href = window.URL.createObjectURL(blob)
            document.body.appendChild(dlLink)
            dlLink.click()
            document.body.removeChild(dlLink)
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.margin-bottom {
  margin-bottom: 10px;
}
.text-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/FwImageModal.vue